module.exports = "data:image/webp;base64,UklGRloAAABXRUJQVlA4IE4AAAAQAwCdASoZABkAPpFCm0olo6IhqAgAsBIJZQC/7BanFAAA/vOHfe9LXDXlXq8vUKlkE1jlmYwAQbTGwoHl2moTkaPe5bvMzqwFr/LwAAA="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/shell.webp
// module id = N+I1
// module chunks = 14